import { RootState } from '../../app/store';

export const selectServiceUnavailable = (state: RootState) =>
  state.layout.isServiceUnavailable;

export const selectSidebarState = (state: RootState) =>
  state.layout.sidebarState;
